//
import { RForm } from '@/components/reusable_components/next'

//
import PchPurchaseInvoiceModel from '@/models/Purchase/PchPurchaseInvoice'
import TranslatorService from '@/services/translator'
import PchPurchaseInvoiceCreateFields from '@/views/Purchase/PchPurchaseInvoice/create/fields'

//
export default {
  name: 'pch-purchase-invoice-create',
  components: {
    RForm,
  },
  computed: {
    formProps() {
      return {
        fields: PchPurchaseInvoiceCreateFields,
      }
    },
  },
  data() {
    return {
      pchPurchaseInvoice: new PchPurchaseInvoiceModel({
        extra_tax: 0,
        is_exent: false,
        payable: false,
        selected: [],
      }),
    }
  },
  methods: {
    redirect() {
      this.$router.push({ name: 'pch-purchase-invoice-list' })
    },
    reset() {
      this.pchPurchaseInvoice = new PchPurchaseInvoiceModel({
        selected: [],
      })
    },
    showError(error) {
      this.showErrorSnackbar(TranslatorService(PchPurchaseInvoiceModel, error.response.data))
    },
    showSuccess() {
      this.showSuccessSnackbar('Factura creada exitosamente.')
    },
    submit() {
      return this
        .toWait(true)
        .then(this.toCreate)
        .then(this.showSuccess)
        .then(this.redirect)
        .catch(this.showError)
        .then(this.toWait)
    },
    toCreate() {
      return this
        .pchPurchaseInvoice
        .toCreateUnique()
        .save()
    },
    toWait(value = false) {
      return this
        .$refs
        .form
        .setWait(value)
    }
  },
  mounted() {
    this.setTitle('Crear factura de compra')
  },
  beforeRouteEnter(to, from, next) {
    next(ctx => {
      if (!ctx.$can('CREATE_PURCHASE_INVOICE')) ctx.$router.push('/')
    })
  },
}